import type { PageTour } from '../types';

export const timesheetTour: PageTour = {
  id: 'timesheet',
  label: 'Timesheet Tour',
  steps: [
    {
      target: '[data-tour="timesheet-header"]',
      title: 'Timesheet',
      content: 'Track your working hours here. Log time against projects and tasks to keep your timesheet up to date.',
    },
    {
      target: '[data-tour="timesheet-week-nav"]',
      title: 'Week Navigation',
      content: 'Navigate between weeks to view or edit past timesheets. Use the arrows or click a specific date.',
    },
    {
      target: '[data-tour="timesheet-grid"]',
      title: 'Time Entry Grid',
      content: 'Enter your hours in the grid. Each row is a project and each column is a day of the week.',
    },
    {
      target: '[data-tour="timesheet-tabs"]',
      title: 'Timesheet Views',
      content: 'Switch between weekly view, daily view, or summary to see your logged hours in different formats.',
    },
  ],
};
